import request from './index';
const cloudMapApi ={
//课后服务开展情况
afterClass(params) {
    return request({
        url:'/dataservice/api/1/1844',
        method: "get",
        params,
    });
},
//课后服务开展明细表
afterClassDetail(params) {
    return request({
        url:'/dataservice/api/1/1845',
        method: "get",
        params,
    });
},
//课后服务开展情况-学校级
afterClassSchool(params) {
    return request({
        url:'/dataservice/api/1/1846',
        method: "get",
        params,
    });
},
//课后服务开展明细表-学校级
afterClassDetailSchool(params) {
    return request({
        url:'/dataservice/api/1/1847',
        method: "get",
        params,
    });
},
//师生出勤率情况
getTeacherAttendance(params) {
    return request({
        url:'/dataservice/api/1/1834',
        method: "get",
        params,
    });
},
//课程开班明细情况
courseStartDetail(params) {
    return request({
        url:'/dataservice/api/1/1835',
        method: "get",
        params,
    });
},
//课程开班总体情况
courseStart(params) {
    return request({
        url:'/dataservice/api/1/1831',
        method: "get",
        params,
    });
},
//学校开课情况
shoolStartCourse(params) {
    return request({
        url:'/dataservice/api/1/1827',
        method: "get",
        params,
    });
},
//课程评价模块
//课程内容总体评价(环形图)
courseAppraise(params) {
    return request({
        url:'/dataservice/api/1/1840',
        method: "get",
        params,
    });
},
//异常评价预警
abnormalAppraise(params) {
    return request({
        url:'/dataservice/api/1/1841',
        method: "get",
        params,
    });
},
//异常评价明细表
abnormalAppraiseDetail(params) {
    return request({
        url:'/dataservice/api/1/1842',
        method: "get",
        params,
    });
},
//教师参与整体情况合并接口
teacherActorAll(params) {
    return request({
        url:'/dataservice/api/1/1848',
        method: "get",
        params,
    });
},
//教师参与整体情况
teacherActor(params) {
    return request({
        url:'/dataservice/api/1/1848',
        method: "get",
        params,
    });
},
//各类课程教师参数总体情况
allCourseTeacher(params) {
    return request({
        url:'/dataservice/api/1/1849',
        method: "get",
        params,
    });
},
//教师参与整体明细表
teacherActorDetail(params) {
    return request({
        url:'/dataservice/api/1/1852',
        method: "get",
        params,
    });
},
//学生参与图
studentParticipate(params){
    return request({
        url:'/dataservice/api/1/1854',
        method: "get",
        params,
    });
},
//学生参与明细表
studentParticipateDetail(params){
    return request({
        url:'/dataservice/api/1/1856',
        method: "get",
        params,
    });
},
//各学校课后服务达标情况
schoolAfterService(params){
    return request({
        url:'/dataservice/api/1/1889',
        method: "get",
        params,
    });
},
//各班级课后服务达标情况
classAfterService(params){
    return request({
        url:'/dataservice/api/1/1890',
        method: "get",
        params,
    });
},
//学校排课情况
schoolArranging(params){
    return request({
        url:'/dataservice/api/1/1895',
        method: "get",
        params,
    });
},
}
export default cloudMapApi
